module.exports = __webpack_public_path__ + "img/mobilen-bipper-1.a4400388.png";